import { motion } from 'framer-motion';
import {
  HiOutlineGlobeAlt,
  HiOutlineCode,
  HiOutlineLightBulb,
  HiOutlineAcademicCap,
} from 'react-icons/hi';
import { profile, education } from '../data/content';
import Reveal from './Reveal';
import './About.css';

const values = [
  {
    icon: HiOutlineCode,
    title: 'Clean & maintainable',
    text: 'I write code I’d be happy to inherit — readable, well-structured, and documented.',
  },
  {
    icon: HiOutlineGlobeAlt,
    title: 'Global experience',
    text: 'Shipped software in Nepal and Japan, collaborating across cultures and time zones.',
  },
  {
    icon: HiOutlineLightBulb,
    title: 'Problem-first',
    text: 'I focus on the real problem before the tech, then pick the right tool for the job.',
  },
];

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container about__grid">
        {/* Visual / portrait card */}
        <Reveal className="about__visual" delay={0}>
          <div className="about__card card">
            <div className="about__avatar">
              <span className="about__initials">
                {profile.firstName[0]}
                {profile.lastName[0]}
              </span>
            </div>
            <div className="about__meta">
              <h3 className="about__meta-name">{profile.name}</h3>
              <p className="about__meta-role">{profile.role}</p>
              <p className="about__meta-loc mono">{profile.location}</p>
            </div>
            <div className="about__edu">
              <HiOutlineAcademicCap className="about__edu-icon" />
              <div>
                <p className="about__edu-school">{education[0].school}</p>
                <p className="about__edu-degree">
                  {education[0].degree}, {education[0].field} ·{' '}
                  <span className="mono">{education[0].period}</span>
                </p>
              </div>
            </div>
            <div className="about__deco" aria-hidden />
          </div>
        </Reveal>

        {/* Narrative */}
        <div className="about__body">
          <Reveal as="div" className="section-head" delay={0.05}>
            <span className="eyebrow">About</span>
            <h2 className="section-title">
              Building software that{' '}
              <span className="gradient-text">people rely on</span>.
            </h2>
          </Reveal>

          <Reveal as="p" className="about__intro" delay={0.12}>
            {profile.intro}
          </Reveal>

          <div className="about__values">
            {values.map((v, i) => (
              <Reveal key={v.title} className="about__value" delay={0.18 + i * 0.08}>
                <span className="about__value-icon">
                  <v.icon />
                </span>
                <div>
                  <h4>{v.title}</h4>
                  <p>{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
